/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDailyTripHistoryResponse } from '../models/ApiResponseDailyTripHistoryResponse';
import type { ApiResponseEvStatsFor30Days } from '../models/ApiResponseEvStatsFor30Days';
import type { ApiResponseEvStatsOfLastDrive } from '../models/ApiResponseEvStatsOfLastDrive';
import type { ApiResponseMonthlyDrivingInfoResponse } from '../models/ApiResponseMonthlyDrivingInfoResponse';
import type { ApiResponseMonthlyStatsResponse } from '../models/ApiResponseMonthlyStatsResponse';
import type { ApiResponseOdometerResponse } from '../models/ApiResponseOdometerResponse';
import type { ApiResponseTripDaysResponse } from '../models/ApiResponseTripDaysResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DrivingHistoryService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 월별 주행 날짜 조회
   * 차량의 월별 주행 날짜를 조회합니다.
   * @returns ApiResponseTripDaysResponse OK
   * @throws ApiError
   */
  public retrieveTripDays1({
    vin,
    month = '202509',
  }: {
    vin: string,
    month?: string,
  }): CancelablePromise<ApiResponseTripDaysResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/days',
      query: {
        'vin': vin,
        'month': month,
      },
    });
  }
  /**
   * 주행 이력 조회
   * 특정 날짜의 주행 이력을 조회합니다.
   * @returns ApiResponseDailyTripHistoryResponse OK
   * @throws ApiError
   */
  public retrieveDailyTripHistory({
    vin,
    date = '20250904',
    orderBy = 'DESC',
  }: {
    vin: string,
    date?: string,
    orderBy?: 'ASC' | 'DESC',
  }): CancelablePromise<ApiResponseDailyTripHistoryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip',
      query: {
        'vin': vin,
        'date': date,
        'orderBy': orderBy,
      },
    });
  }
  /**
   * 누적 주행 거리 조회
   * 차량의 누적 주행 거리를 조회합니다
   * @returns ApiResponseOdometerResponse OK
   * @throws ApiError
   */
  public retrieveOdometer({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseOdometerResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/odometer',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 월별 주행 통계 조회
   * 차량의 월별 주행 통계를 조회합니다(최대 3개월)
   * @returns ApiResponseMonthlyStatsResponse OK
   * @throws ApiError
   */
  public retrieveMonthlyStats1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseMonthlyStatsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/monthly-stats',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * EV Statistics Of Last Drive
   * EV Statistics Of Last Drive
   * @returns ApiResponseEvStatsOfLastDrive OK
   * @throws ApiError
   */
  public retrieveEvStatsOfLastDrive({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseEvStatsOfLastDrive> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/ev-stats/recent',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * EV Statistics For 30 Days
   * EV Statistics For 30 Days
   * @returns ApiResponseEvStatsFor30Days OK
   * @throws ApiError
   */
  public retrieveEvStatsFor30Days({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseEvStatsFor30Days> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/ev-stats',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 월별 주행 정보 조회
   * 차량의 월별 주행 정보를 조회합니다.
   * @returns ApiResponseMonthlyDrivingInfoResponse OK
   * @throws ApiError
   */
  public retrieveDrivingInfo({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseMonthlyDrivingInfoResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/car/trip/driving-info',
      query: {
        'vin': vin,
      },
    });
  }
}
